import {Component, Input, OnInit} from '@angular/core';
import {ExportExcelParams} from "app/dar/common/services";
import {finalize} from "rxjs/operators";
import {FileSaverService, Individu, PubSubService} from "@Common/core/services";
import {SubSink} from "@Common/core/utils/subsink";
import {DarDossiersGestService} from "app/dar/common/services/dossiers/dossiers-gest.service";
import {MatDatepickerInputEvent} from "@angular/material/datepicker";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {DateHelperService} from "app/dar/common/services/date-helper/date-helper.service";

@Component({
  selector: 'app-export-excel',
  templateUrl: './export-excel.component.html',
  styleUrls: ['./export-excel.component.scss']
})
export class ExportExcelComponent implements OnInit {
  subSink = new SubSink();
  @Input() owner?: Individu = null;
  @Input() byDate ? = false;
  @Input() tooltip = 'Export excel des demandes';

  periodeFormGroup: UntypedFormGroup;
  minDate = null;

  constructor(
    private pubSubSvc: PubSubService,
    private dossiersGestSvc: DarDossiersGestService,
    private fileService: FileSaverService,
    private formBuilder: UntypedFormBuilder,
    public dateSvc: DateHelperService,
              ) {
    this.periodeFormGroup = this.formBuilder.group({
      date_debut: [],
      date_fin: [],
    });
  }

  ngOnInit(): void {
  }

  generateExcel() {
    this.pubSubSvc.publish('loading', true);
    const params: ExportExcelParams = {};
    if (this.owner) {
      params.owner = this.owner;
    }
    if (this.byDate) {
      const date_from = this.dateSvc.transformDateToYYYYMMDD(this.periodeFormGroup.controls['date_debut'].value);
      const date_to = this.dateSvc.transformDateToYYYYMMDD(this.periodeFormGroup.controls['date_fin'].value);
      params.by_date_range = `${date_from}_${date_to}`;
    }
    this.subSink.sink = this.dossiersGestSvc.exportExcel(params)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((_excel) => {
        const filename = `EXPORT_DAR`;
        this.fileService.FileSave(_excel, filename, 'xlsx');
      });
  }

  enableExport() {
    if (this.byDate) {
      const dateDebut = this.periodeFormGroup.controls['date_debut'].value;
      const dateFin = this.periodeFormGroup.controls['date_fin'].value;
      return dateDebut && dateFin;
    }
    return true;
  }

  onDateSelected(dte: MatDatepickerInputEvent<Date>, control = '') {
    if (control === 'debut') {
      this.minDate = dte.value;
    }
  }
}
